import { z } from 'zod';
export var RecruitmentPartner = z.object({
  id: z.number(),
  email: z.string(),
  agentInformation: z.object({
    companyName: z.string().nullish()
  }),
  personalInformation: z.object({
    firstName: z.string(),
    lastName: z.string().nullish(),
    phone: z.string().nullish()
  }),
  addressInformation: z.object({
    countryCode: z.string()
  }),
  agentManager: z.object({
    email: z.string(),
    fullName: z.string()
  }).nullish()
});
export var RecruitmentPartnerResponse = z.object({
  id: z.string(),
  type: z.literal('recruitment_partner'),
  attributes: z.object({}).passthrough()
});